export default function PromoDestinos({ hasBg }) {
    return (
        <>
            <div className="overflow-hidden">
                <section
                    id="pricing"
                    className={`package-section ${hasBg ? "gray-light-bg" : "background-shape-right"
                        } ptb-100`}
                >
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <div className="section-heading text-center mb-5">
                                    <h2>
                                        Elegí el viaje que mas se ajuste a vos <br />
                                    </h2>
                                    {/* <p className="lead">
                                    Nos especializamos en crear experiencias inolvidables para estudiantes que desean vivir una experiencia ùnica en su viaje de egresados. Desde aventuras educativas hasta fiestas inolvidables, estamos aquí para llevar tu viaje al siguiente nivel
                                    </p> */}
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-4 col-md">
                                <div className="card text-center single-pricing-pack p-5">
                                    <h5 className="mb-2">Primario</h5>
                                    <div className="pricing-img mt-3 mb-4">
                                        <img
                                            // src="assets/img/basic.svg"
                                            src="assets/img/PRIMARIOS50x50.png"
                                            alt="pricing img"
                                            className="img-fluid"
                                        />
                                    </div>

                                    <div className="card-body p-0">
                                        <ul className="list-unstyled text-sm pricing-feature-list">
                                            <li>Carlos Paz</li>
                                            <li>San Pedro</li>
                                            <li>Ramallo</li>
                                            <li>Costa Atlántica</li>
                                        </ul>
                                        <div className="py-4 border-0 pricing-header">
                                            {/* <div className="h1 text-center mb-0 color-secondary">
                          $<span className="price font-weight-bolder">29</span>
                        </div> */}
                                        </div>
                                        <a href="/primarios" className="btn outline-btn">
                                            Conoce nuestros destinos
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md">
                                <div className="card text-center popular-price single-pricing-pack p-5">
                                    <h5 className="mb-2">Secundario</h5>
                                    <div className="pricing-img mt-3 mb-4">
                                        <img
                                            // src="assets/img/standard.svg"
                                                  src="assets/img/SECUNDARIOS50x50.png"
                                            alt="pricing img"
                                            className="img-fluid"
                                        />
                                    </div>

                                    <div className="card-body p-0">
                                        <ul className="list-unstyled text-sm pricing-feature-list">
                                            <li>Bariloche</li>
                                            <li>Villa Carlos Paz</li>
                                            <li>Costa Atlántica</li>
                                            <li>Brasil</li>
                                        </ul>
                                        <div className="py-4 border-0 pricing-header">
                                            {/* <div className="h1 text-center mb-0 color-secondary">
                          $<span className="price font-weight-bolder">145</span>
                        </div> */}
                                        </div>
                                        <a href="/secundarios" className="btn solid-btn">
                                            Conoce nuestros destinos
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-5 text-center">
                            <p className="mb-2">
                                Si tenés dudas acerca de nuestros servicios exclusivos. 
                                <a href="#contact" className="color-secondary">
                                    {" "}
                                    Contactanos{" "}
                                </a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}
